import yup from 'core/utils/validators';
import { FIELD_REQUIRED, AADHAR_FIELD_LENGTH } from 'const';

const { object, string } = yup;

export const aadhaarVerificationFormSchema = () => {
  return object().shape({
    aadhaar_number: string()
      .transform((value: string) => value.replace(/\s/g, ''))
      .min(12, AADHAR_FIELD_LENGTH)
      .required(FIELD_REQUIRED),
  });
};

export const aadhaarOtpFormSchema = () => {
  return object().shape({
    otp: string().min(6, 'message_aadhaar_otp_length').required('message_aadhaar_otp_required'),
  });
};
